export enum OrdemCargaTypes {
  'LOAD_REQUEST' = '@ordemCarga/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@ordemCarga/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@ordemCarga/LOAD_FAILURE',

  'CLEAN_ORDEMCARGA' = '@ordemCarga/CLEAN_ORDEMCARGA',
}

export interface Pedidos {
  nuNota: number;
  numNota: number;
  codFornecedor: number;
  codDestinatario: number;
  pesoBruto: number;
  valor: number;
  destinatario: string;
  fornecedor: string;
  observacao: string;
  cidadeOrigem: string;
  qtdVolume: number;
  tipoVolume: string;
  nunotaEmitida: number;
  produto: string;
  nomeCD: string;
  temAnexo: number;
}

export interface IOrdemCarga {
  codEmp: number;
  codCdd: number;
  nomeCdd: string;
  ordemCarga: number;
  tipoWms: string;
  placa: string;
  cpfMotorista: string;
  motorista: string;
  status: string;
  pesoTotal: number;
  vlrTotal: number;
  transportadora: string;
  destinatario: string;
  agendavel: boolean;
  tipVei: string;
  codMotorista: number;
  codVeiculo: number;
  codDestinatario: number;
  clienteRetira: boolean;
  tipoCarga: string;
  assoalho: string;
  codTransportadora: number;
  codTipVeiculo: number;
  pedidos: Pedidos[];
}

export interface OrdemCargaState {
  readonly data: IOrdemCarga | undefined;
  readonly loading: boolean;
  readonly error: boolean;
}
